import { axiosSwagger } from "@/axios";
import _orderBy from 'lodash/orderBy';

export const state = {
    group: {
        loading: false,
        data: [],
        total: 0,
    },
}


export const getters = {
}


export const mutations = {
    // ACCESS LEVEL
    loading: (state, loading) => {
        state.group.loading = loading;
    },
    setData: (state, data) => {
        state.group.data = _orderBy(data, 'group', 'asc');
    },
    setTotal: (state, total) => {
        state.group.total = total;
    },
    add: (state, data) => {
        state.group.data.push(data);
    },
    remove: (state, id) => {
        state.group.data = state.group.data.filter((el) => el.id !== id);
    },
    update: (state, data) => {
        const index = state.group.data.findIndex(
            (item) => item.id === data.id
        );

        if (index !== -1) {
            state.group.data[index].group = data.group;
        }
    },
}


export const actions = {
    // CATEGORY GROUP
    // eslint-disable-next-line no-unused-vars
    async readCategoryGroupById({ commit }, id) {
        return await axiosSwagger
            .get(`/api/DocumentCategoryGroup/${id}`)
            .then((response) => {

                return response;
            });
    },
    async readCategoryGroup({ commit }) {
        commit("loading", true);

        return await axiosSwagger
        .get("/api/DocumentCategoryGroup/All")
        .then((response) => {
            commit("setData", response.data);
            commit("setTotal", response.data.length);
            commit("loading", false);

            return response;
        })
        .catch(() => {
            commit("loading", false);
        });
    },
    async createCategoryGroup({ commit }, data) {
        return await axiosSwagger
        .post('/api/DocumentCategoryGroup/Create', data)
        .then((response) => {
            commit("add", response.data);

            return response;
        });
    },
    async deleteCategoryGroup({ commit }, id) {
        return await axiosSwagger
        .delete(`/api/DocumentCategoryGroup/${id}`)
        .then((response) => {
            commit("remove", id);

            return response;
        });
    },
    async updateCategoryGroup({ commit }, data) {
        return await axiosSwagger
        .put(`/api/DocumentCategoryGroup/${data.id}`, data)
        .then((response) => {
            commit("update", data);

            return response;
        });
    },
}